// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__lgv66","name":"ConsentHeader_name__2DgUG","birthday":"ConsentHeader_birthday__2ExXr","skeleton":"ConsentHeader_skeleton__1l0An"};